import Vue from 'vue'
import Router from 'vue-router'
import Home from '../views/Home.vue'
import Products from '../views/Products.vue'
import Contact from '../views/Contact.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    { path: '/', name: 'Home', component: Home },
    { path: '/products', name: 'Products', component: Products },
    { path: '/contact', name: 'Contact', component: Contact }
  ]
})

// 路由切换时滚动到顶部
router.afterEach(() => {
  window.scrollTo(0, 0)
})

export default router
